import "@/App.css";
import { useState } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import LeistungenSection from "@/components/LeistungenSection";
import UeberUnsSection from "@/components/UeberUnsSection";
import TeamSection from "@/components/TeamSection";
import ProzessSection from "@/components/ProzessSection";
import BewertungenSection from "@/components/BewertungenSection";
import ReferenzenSection from "@/components/ReferenzenSection";
import HistorienSection from "@/components/HistorienSection";
import InhaberSection from "@/components/InhaberSection";
import CTASection from "@/components/CTASection";
import SocialSection from "@/components/SocialSection";
import KontaktSection from "@/components/KontaktSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Impressum from "@/components/Impressum";
import Datenschutz from "@/components/Datenschutz";
import CookieConsent from "@/components/CookieConsent";
import SEOSchema from "@/components/SEOSchema";

function App() {
  const [showImpressum, setShowImpressum] = useState(false);
  const [showDatenschutz, setShowDatenschutz] = useState(false);

  return (
    <div className="App" data-testid="app-container">
      <SEOSchema />
      {showImpressum && <Impressum onClose={() => setShowImpressum(false)} />}
      {showDatenschutz && <Datenschutz onClose={() => setShowDatenschutz(false)} />}
      <Navbar />
      <HeroSection />
      <LeistungenSection />
      <UeberUnsSection />
      <TeamSection />
      <HistorienSection />
      <InhaberSection />
      <ProzessSection />
      <BewertungenSection />
      <ReferenzenSection />
      <CTASection />
      <SocialSection />
      <KontaktSection />
      <FAQSection />
      <Footer onShowImpressum={() => setShowImpressum(true)} onShowDatenschutz={() => setShowDatenschutz(true)} />
      <WhatsAppButton />
      <CookieConsent />
    </div>
  );
}

export default App;
